import React from 'react'
import InputNumber from 'antd/lib/input-number'
import styled from '@emotion/styled'

const ALLOWED_KEYS = new Set([
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End'
])

const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey) return
  if (ALLOWED_KEYS.has(e.key)) return
  if (/^\d$/.test(e.key)) return
  e.preventDefault()
}

const StyledInputNumber = styled(InputNumber)`
  width: 100%;
  .ant-input-number-input-wrap {
    width: 100%;
  }
`

const FullWidthInputNumber = (
  props: React.ComponentProps<typeof InputNumber>
) => <StyledInputNumber onKeyDown={handleKeyDown} {...props} />

export default FullWidthInputNumber
